const premiereArray = [
  {
    index: 0,
    img: "https://assets-in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:l-image,i-discovery-catalog@@icons@@bms_premiere_v1.png,t-false,lfo-bottom_left,l-end/et00327975-nwypjjsddr-portrait.jpg",
    name: "Chitrakut",
    lang: "Hindi",
  },
  {
    index: 1,
    img: "https://assets-in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:l-image,i-discovery-catalog@@icons@@bms_premiere_v1.png,t-false,lfo-bottom_left,l-end/et00418174-vdbggkecmz-portrait.jpg",
    name: "Ella",
    lang: "Hindi",
  },
  {
    index: 2,
    img: "https://assets-in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:l-image,i-discovery-catalog@@icons@@bms_premiere_v1.png,t-false,lfo-bottom_left,l-end/et00425532-slhjxrhffc-portrait.jpg",
    name: "Three Man",
    lang: "Italian",
  },
  {
    index: 3,
    img: "https://assets-in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:l-image,i-discovery-catalog@@icons@@bms_premiere_v1.png,t-false,lfo-bottom_left,l-end/et00422442-awapmehnwy-portrait.jpg",
    name: "Saturday Night",
    lang: "English",
  },
  {
    index: 4,
    img: "https://assets-in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:l-image,i-discovery-catalog@@icons@@bms_premiere_v1.png,t-false,lfo-bottom_left,l-end/et00383011-eqcwrkgetj-portrait.jpg",
    name: "Sentimentaaal",
    lang: "Bengali",
  },
  {
    index: 5,
    img: "https://assets-in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:l-image,i-discovery-catalog@@icons@@bms_premiere_v1.png,t-false,lfo-bottom_left,l-end/et00423394-czqzgpszyu-portrait.jpg",
    name: "Cash Out",
    lang: "English",
  },
  {
    index: 6,
    img: "https://assets-in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:l-image,i-discovery-catalog@@icons@@bms_premiere_v1.png,t-false,lfo-bottom_left,l-end/et00390921-wyskhzfzjc-portrait.jpg",
    name: "Bengal 1947",
    lang: "Hindi",
  },
];

export default premiereArray;
